import { createStyles } from 'antd-style'

export const useStyles = createStyles(() => ({
  initials: {
    filter: 'invert(1) grayscale(1) brightness(1.3) contrast(9000)',
    mixBlendMode: 'luminosity',
    opacity: 0.95
  },

  avatar: {
    '&.ant-avatar': {
      border: 0
    }
  }
}))
